
export const riskCategories = [
    { label: "Cost", value: "Cost" },
    { label: "Schedule", value: "Schedule" },
    { label: "Scope", value: "Scope" },
    { label: "Regulatory & Legal", value: "Regulatory & Legal" },
    { label: "HSE", value: "HSE" },
    { label: "QA/QC", value: "QA/QC" },
    { label: "Reputational", value: "Reputational" },
    { label: "Weather & Force Majeure", value: "Weather & Force Majeure" },
    { label: "Supply Chain & Logistics", value: "Supply Chain & Logistics" }
];

export const impactCategories = [
    { label: "Cost Impact", value: "Cost Impact" },
    { label: "Schedule Impact", value: "Schedule Impact" },
    { label: "Scope Impact", value: "Scope Impact" },
    { label: "Regulatory & Legal Impact", value: "Regulatory & Legal Impact" },
    { label: "Safety Impact", value: "Safety Impact" },
    { label: "Quality Impact", value: "Quality Impact" },
    { label: "Reputational Impact", value: "Reputational Impact" },
    { label: "Cyber/Information Security/Data Impact", value: "yber/Information Security/Data Impact" },
    { label: "Multiple", value: "Multiple" }
];

export const riskImpacts = [
    { label: "5(Expected)", value: "5" },
    { label: "4(Highly Expected)", value: "4" },
    { label: "3(Likely)", value: "3" },
    { label: "2(Not Likely)", value: "2" },
    { label: "1(Rare)", value: "1" }
];

export const riskLikelihood = [
    { label: "5(Expected)", value: "5" },
    { label: "4(Highly Expected)", value: "4"},
    { label: "3(Likely)", value: "3" },
    { label: "2(Not Likely)", value: "2"},
    { label: "1(Rare)", value: "1" }
];


export const riskSeverity = [
    { label: "Critical", value: "Critical" },
    { label: "Moderate", value: "Moderate" },
    { label: "Low", value: "Low" },
];

export const riskStatus = [
    { label: "Active", value: "Active" },
    { label: "In Active", value: "In Active" },
    { label: "Completed", value: "Completed" },
   
];


export const riskResponsible = [
  { label: "Central PMO", value: "Central PMO" },
  { label: "Site PMO", value: "Site PMO" },
  { label: "DM", value: "DM" },
  { label: "GRIL", value: "GRIL" },
  { label: "EPC Contractor", value: "EPC Contractor" },
  { label: "DM and GRIP", value: "DM and GRIP" },
  { label: "GRIP and Authority", value: "GRIP and Authority" },
  { label: "GRIP", value: "GRIP" },
//   { label: "GRIL", value: "GRIL" },
  
];

export const MitigationactionStatus = [
    { label: "Not Started", value: "Not Started" },
    { label: "In Progress", value: "In Progress" },
    { label: "Completed", value: "Completed" },
    { label: "Scheduled", value: "Scheduled" }
];